export enum TeamCompetitionStatus {
  Registered = "registered",
  PaymentInProgress = "payment_in_progress",
  Accepted = "accepted",
}

export enum TeamCompetitionExemptionReason {
  Journalist = "journalist",
  PastWinner = "past_winner",
  Vip = "vip",
  Other = "other",
}

export const TeamCompetitionStatusTranslations: Record<TeamCompetitionStatus, string> = {
    [TeamCompetitionStatus.Registered]: "Registrado",
    [TeamCompetitionStatus.PaymentInProgress]: "Pago en curso",
    [TeamCompetitionStatus.Accepted]: "Pagado",
  } as const;

  export const TeamCompetitionStatusColors = {
    [TeamCompetitionStatus.Registered]: "blue",
    [TeamCompetitionStatus.PaymentInProgress]: "yellow",
    [TeamCompetitionStatus.Accepted]: "green",
  } as const;


export const TeamCompetitionExemptionReasonTranslations: Record<TeamCompetitionExemptionReason, string> = {
  [TeamCompetitionExemptionReason.Journalist]: "Periodista",
  [TeamCompetitionExemptionReason.PastWinner]: "Ganador Pasado",
  [TeamCompetitionExemptionReason.Vip]: "VIP",
  [TeamCompetitionExemptionReason.Other]: "Otro",
} as const;

export interface TeamCompetition {
  id: number;
  competition_id: number;
  team_id: number;
  registration_number: number;
  is_payment_exempt: boolean;
  exemption_reason?: TeamCompetitionExemptionReason;
  exemption_notes?: string;
  status?: TeamCompetitionStatus;
  team_number?: number;
  group?: string;
  registration_date: Date;
  accepted_date?: Date;
  created_at: Date;
  updated_at: Date;
}
